import React, { useEffect, useState } from "react";
import { Col, Form, ListGroup, Row } from "react-bootstrap";
import { Buttton, Cards, Inputs, Modaal } from "../../../components";
import {
  PiHospitalLight,
  PiFolderUserLight,
  PiCalendar,
  PiFirstAidLight,
} from "react-icons/pi";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { actionDoctor, actionPatient } from "../../../redux/actions";
import { useAlert, useToast } from "../../../contexts";

const PatientInformationAndSymptoms = (loginData) => {
  const { t } = useTranslation();
  const { showAlert } = useAlert();
  const { showToast } = useToast();
  const location = useLocation();
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [credentials, setCredentials] = useState({
    patientGuid: "",
    firstName: "",
    lastName: "",
    socialSecurityNumber: "",
    phone: "",
    address: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prevCredentials) => ({
      ...prevCredentials,
      [name]: value,
    }));
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };

      if (name === "firstName" && value.length >= 2) {
        delete updatedErrors.firstName;
      }
      if (name === "lastName" && value.length >= 2) {
        delete updatedErrors.lastName;
      }
      if (name === "email" && /\S+@\S+\.\S+/.test(value)) {
        delete updatedErrors.email;
      }

      return updatedErrors;
    });
  };
  const appointment = location.state?.appointment;
  const getDiagnosticByIdData = useSelector(
    (state) => state.doctor.getDiagnosticByIdData?.data
  );

  const getAllAppointmentDetailData = useSelector(
    (state) => state.doctor.getAllAppointmentDetailData?.data
  );
  const getAdditionalServiceInfoData = useSelector(
    (state) => state.doctor.getAdditionalServiceInfoData?.data
  );

  useEffect(() => {
    if (showModal) {
      const patientGuid = getDiagnosticByIdData?.result?.appDetail?.patientGuid;
      if (patientGuid) {
        dispatch(actionPatient.getPatientById(patientGuid));
      }
    }
  }, [
    dispatch,
    getDiagnosticByIdData?.result?.appDetail?.patientGuid,
    showModal,
  ]);

  const getpatientByIdData = useSelector(
    (state) => state.patient.getpatientByIdData?.data
  );

  useEffect(() => {
    if (getpatientByIdData) {
      setCredentials((prev) => ({
        ...prev,
        patientGuid: getpatientByIdData?.result?.userGuid,
        firstName: getpatientByIdData?.result?.firstName,
        lastName: getpatientByIdData?.result?.lastName,
        socialSecurityNumber: getpatientByIdData?.result?.socialSecurityNumber,
        phone: getpatientByIdData?.result?.phone,
        address: getpatientByIdData?.result?.address,
      }));
    }
  }, [getpatientByIdData]);

  const handleFormClick = () => {
    dispatch(
      actionPatient.postSavePatientDetail(credentials, (error, response) => {
        if (error) {
          if (error.data) {
            if (error.data.statusCode === 400) {
              if (error.data.error && error.data.error.ValidationErrors) {
                error.data.error.ValidationErrors.forEach((validationError) => {
                  console.error(
                    `${t("Field")}: ${validationError.Field} - ${t(
                      "Message"
                    )}: ${validationError.Message}`
                  );

                  showAlert(
                    "danger",
                    validationError.Message,
                    `${t("Error")} : ${validationError.Field}`
                  );
                });
              } else {
                showAlert(
                  "danger",
                  t("Invalid_credentials"),
                  `${t("Error")} !`
                );
              }
            } else {
              showAlert("danger", t("unexpected_error"), `${t("Error")} !`);
            }
          }
        } else if (response) {
          dispatch(
            actionDoctor.getDiagnosticById(
              appointment?.appointmentGuid,
              loginData?.currencyCode
            )
          );
          if (response.status === 200) {
            showToast(
              `${t("success")}`,
              `${t(
                "doctor.diagnostic_report.patient_details_saved_successfully"
              )}`,
              5000,
              true,
              "top-end toast-success"
            );
            setShowModal(false);
          }
        }
      })
    );
  };

  return (
    <>
      <Row>
        <Col>
          <Cards.Cardd
            header={
              <>
                <div className="blkIcon">
                  <PiHospitalLight className="iicon" />
                </div>
                <h5 className="exado-title-seven card-header-text">
                  {t("Clinic")} {t("Information")}
                </h5>
              </>
            }
            content={
              <ListGroup className="card-content-list">
                <ListGroup.Item>
                  <label className="card-list-lable">{t("Clinic")} :</label>
                  <p className="card-list-content exado-title-six">
                    {appointment?.clinicName}
                  </p>
                </ListGroup.Item>
                <ListGroup.Item>
                  <label className="card-list-lable">{t("Address")} :</label>
                  <p className="card-list-content exado-title-six">
                    {getDiagnosticByIdData?.result?.appDetail?.address}{" "}
                  </p>
                </ListGroup.Item>
                <ListGroup.Item>
                  <label className="card-list-lable">
                    {t("contact_details")} :{" "}
                  </label>
                  <p className="card-list-content exado-title-six">
                    {t("phone_number")}:{" "}
                    {getDiagnosticByIdData?.result?.appDetail?.phone}
                  </p>
                  <p className="card-list-content exado-title-six">
                    {t("email")} {t("Address")}:{" "}
                    {getDiagnosticByIdData?.result?.appDetail?.email}
                  </p>
                </ListGroup.Item>
              </ListGroup>
            }
            className="cardd"
          />
        </Col>
        <Col>
          <Cards.Cardd
            header={
              <>
                <div className="blkIcon">
                  <PiFolderUserLight className="iicon" />
                </div>
                <h5 className="exado-title-seven card-header-text">
                  {t("patient_information")}
                </h5>
              </>
            }
            content={
              <ListGroup className="card-content-list">
                <ListGroup.Item>
                  <p className="exado-title-six">
                    {t("Insurance_Nr")} :{" "}
                    {
                      getAllAppointmentDetailData?.result?.patientData
                        ?.socialSecurityNumber
                    }{" "}
                  </p>
                </ListGroup.Item>
                <ListGroup.Item>
                  <label className="card-list-lable">
                    {t("patient_details")} :
                  </label>
                  <p className="card-list-content exado-title-six">
                    {getDiagnosticByIdData?.result?.appDetail?.patientName}{" "}
                  </p>
                </ListGroup.Item>
                <ListGroup.Item>
                  <label className="card-list-lable">{t("Address")} : </label>
                  <p className="card-list-content exado-title-six">
                    {getAllAppointmentDetailData?.result?.patientData?.address}
                  </p>
                </ListGroup.Item>
                <ListGroup.Item>
                  <label className="card-list-lable">
                    {t("contact_details")} :{" "}
                  </label>
                  <p className="card-list-content exado-title-six">
                    {t("phone_number")}:{" "}
                    {getAllAppointmentDetailData?.result?.patientData?.phone}
                  </p>
                  <p className="card-list-content exado-title-six">
                    {t("email")} {t("Address")}:{" "}
                    {getAllAppointmentDetailData?.result?.patientData?.email}
                  </p>
                </ListGroup.Item>
              </ListGroup>
            }
            footer={
              appointment?.externalUser && (
                <Buttton.Buttton
                  className="btn-solid-Aqua_Teal"
                  children="EDIT"
                  onClick={() => setShowModal(true)}
                />
              )
            }
            className="cardd"
          />
        </Col>
        <Col>
          <Cards.Cardd
            header={
              <>
                <div className="blkIcon">
                  <PiCalendar className="iicon" />
                </div>
                <h5 className="exado-title-seven card-header-text">
                  {t("appointment")} {t("Information")}
                </h5>
              </>
            }
            content={
              <ListGroup className="card-content-list">
                <ListGroup.Item>
                  <label className="card-list-lable">{t("date")} :</label>
                  <p className="exado-title-six">
                    {new Date(
                      getDiagnosticByIdData?.result?.appDetail?.appointmentDate
                    )
                      .toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                      })
                      .replace(",", "th,")}
                  </p>
                </ListGroup.Item>
                <ListGroup.Item>
                  <label className="card-list-lable">{t("time")} :</label>
                  <p className="card-list-content exado-title-six">
                    {new Date(
                      getDiagnosticByIdData?.result?.appDetail?.appointmentDate
                    ).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </p>
                </ListGroup.Item>
                <ListGroup.Item>
                  <label className="card-list-lable">
                    {t("booking_id")} :{" "}
                  </label>
                  <p className="card-list-content exado-title-six">
                    {getDiagnosticByIdData?.result?.appDetail?.bookingId}
                  </p>
                </ListGroup.Item>
                <ListGroup.Item>
                  <label className="card-list-lable">
                    {t("consultation_fee")} :{" "}
                  </label>
                  <p className="card-list-content exado-title-six">
                    {getDiagnosticByIdData?.result?.appDetail?.consultFees +
                      getAdditionalServiceInfoData?.result?.totalAmount +
                      " " +
                      getDiagnosticByIdData?.result?.appDetail
                        ?.appointmentCurrency}
                  </p>
                </ListGroup.Item>
              </ListGroup>
            }
            className="cardd"
          />
        </Col>
      </Row>
      <Row className="exado-sub-row1">
        <Col>
          <Cards.Cardd
            header={
              <>
                <div className="blkIcon">
                  <PiFirstAidLight className="iicon" />
                </div>
                <h5 className="exado-title-seven card-header-text">
                  {t(
                    "doctor.diagnostic_report.before_consultation_patient_given_information"
                  )}
                </h5>
              </>
            }
            content={
              <ListGroup className="card-content-list">
                <ListGroup.Item>
                  <label className="card-list-lable">
                    <div className="blkIcon">Q</div>
                    <span className="exado-title-seven">
                      {t(
                        "doctor.diagnostic_report.describe_problem_or_symptoms"
                      )}
                    </span>
                  </label>
                  <p className="exado-title-six card-list-ans">
                    <div className="blkIcon">A</div>
                    <span>
                      {
                        getAllAppointmentDetailData?.result
                          ?.patientAppointmentDetail?.symptoms
                      }
                    </span>
                  </p>
                </ListGroup.Item>
                <ListGroup.Item>
                  <label className="card-list-lable">
                    <div className="blkIcon">Q</div>
                    <span className="exado-title-seven">
                      {t(
                        "doctor.diagnostic_report.since_when_symptoms_are_active"
                      )}
                    </span>
                  </label>
                  <p className="exado-title-six card-list-ans">
                    <div className="blkIcon">A</div>
                    <span>
                      {
                        getAllAppointmentDetailData?.result
                          ?.patientAppointmentDetail?.sinceWhen
                      }
                    </span>
                  </p>
                </ListGroup.Item>
                <ListGroup.Item>
                  <label className="card-list-lable">
                    <div className="blkIcon">Q</div>
                    <span className="exado-title-seven">
                      {t(
                        "doctor.diagnostic_report.is_any_medication_or_treatment_taken_yet"
                      )}
                    </span>
                  </label>
                  <p className="exado-title-six card-list-ans">
                    <div className="blkIcon">A</div>
                    <span>
                      {
                        getAllAppointmentDetailData?.result
                          ?.patientAppointmentDetail?.anyMedication
                      }
                    </span>
                  </p>
                </ListGroup.Item>
                <ListGroup.Item>
                  <label className="card-list-lable">
                    <div className="blkIcon">Q</div>
                    <span className="exado-title-seven">
                      {t(
                        "doctor.diagnostic_report.has_a_diagnosis_been_given"
                      )}
                    </span>
                  </label>
                  <p className="exado-title-six card-list-ans">
                    <div className="blkIcon">A</div>
                    <span>
                      {
                        getAllAppointmentDetailData?.result
                          ?.patientAppointmentDetail?.diagnosisGiven
                      }
                    </span>
                  </p>
                </ListGroup.Item>
              </ListGroup>
            }
            footer={
              <Buttton.Buttton
                className="btn-solid-Aqua_Teal"
                children={t("doctor.diagnostic_report.patient_history")}
              />
            }
            className="cardd piqa-cardd"
          />
        </Col>
      </Row>
      <Modaal.Modaal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        centered="true"
        title={<h2 className="exado-title-nine">{t("patient_information")}</h2>}
        bodyContent={
          <Form className="patientInfo-form">
            <Row className="pi-row">
              <Form.Label className="exado-title-six pi-lable">
                {t("doctor.diagnostic_report.patient_personal_information")}
              </Form.Label>
              <Col md={12}>
                <Row>
                  <Inputs.FormInputs
                    label={
                      errors.socialSecurityNumber ? (
                        <span className="error-message">
                          {" "}
                          {errors.socialSecurityNumber}
                        </span>
                      ) : (
                        `${t("social_security_number")}`
                      )
                    }
                    name="socialSecurityNumber"
                    value={credentials.socialSecurityNumber}
                    onChange={handleChange}
                    grpClassname={`form-group ${errors.socialSecurityNumber ? "form-group-error" : ""
                      }`}
                    md={6}
                  // disabled={!isEditVisible}
                  />
                </Row>
              </Col>
              <Col md={6} className="pi-col">
                <Row>
                  <Inputs.FormInputs
                    label={
                      errors.firstName ? (
                        <span className="error-message">
                          {" "}
                          {errors.firstName}
                        </span>
                      ) : (
                        `${t("first_name")}`
                      )
                    }
                    name="firstName"
                    value={credentials.firstName}
                    onChange={handleChange}
                    grpClassname={`form-group ${errors.firstName ? "form-group-error" : ""
                      }`}
                  // disabled={!isEditVisible}
                  />
                </Row>
              </Col>
              <Col md={6} className="pi-col">
                <Row>
                  <Inputs.FormInputs
                    label={
                      errors.lastName ? (
                        <span className="error-message">
                          {" "}
                          {errors.lastName}
                        </span>
                      ) : (
                        `${t("last_name")}`
                      )
                    }
                    name="lastName"
                    value={credentials.lastName}
                    onChange={handleChange}
                    grpClassname={`form-group ${errors.lastName ? "form-group-error" : ""
                      }`}
                  // disabled={!isEditVisible}
                  />
                </Row>
              </Col>
            </Row>
            <Row className="">
              <Form.Label className="exado-title-six pi-lable">
                {t("doctor.diagnostic_report.patient_contact_information")}
              </Form.Label>
              <Col>
                <Row>
                  <Inputs.FormInputs
                    label={
                      errors.address ? (
                        <span className="error-message"> {errors.address}</span>
                      ) : (
                        `${t("Address")}`
                      )
                    }
                    name="address"
                    value={credentials.address}
                    onChange={handleChange}
                    grpClassname={`form-group ${errors.address ? "form-group-error" : ""
                      }`}
                  // disabled={!isEditVisible}
                  />
                </Row>
              </Col>
              .
              <Col>
                <Row>
                  <Inputs.FormInputs
                    label={
                      errors.phone ? (
                        <span className="error-message"> {errors.phone}</span>
                      ) : (
                        `${t("phone_number")}`
                      )
                    }
                    name="phone"
                    value={credentials.phone}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        setCredentials({ ...credentials, phone: value });
                      }
                    }}
                    grpClassname={`form-group ${errors.phone ? "form-group-error" : ""
                      }`}
                    maxLength={10}
                  // disabled={!isEditVisible}
                  />
                </Row>
              </Col>
            </Row>
          </Form>
        }
        footer={
          <>
            <Buttton.Buttton
              children={`${t("CANCEL")}`}
              className="btn-border-Aqua_Teal"
              onClick={() => setShowModal(false)}
            />
            <Buttton.Buttton
              children={`${t("Save")}`}
              className="btn-solid-Aqua_Teal"
              onClick={handleFormClick}
            />
          </>
        }
        backdrop="static"
        className="input-modal patient-details-modal"
      />
    </>
  );
};

export default PatientInformationAndSymptoms;
